<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Underline')"
        :disabled="disabled || !editor.can().chain().focus().toggleUnderline().run()"
        :class="{ 'is-active': editor.isActive('underline') }"
        @click="editor.chain().focus().toggleUnderline().run()">
        <FormatUnderlineIcon size="16"/>
    </button>
</template>

<script>
import FormatUnderlineIcon from '@/common/components/svg-icons/FormatUnderlineIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarUnderlineButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatUnderlineIcon
    }
};
</script>
